// Minimal Vojomo symbol for use within the Roadmap Builder
// (The full app shell handles the main header logo)
import type React from "react";

interface VojomoSymbolProps {
  className?: string;
  style?: React.CSSProperties;
}

export function VojomoSymbol({ className, style }: VojomoSymbolProps) {
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="20" cy="20" r="20" fill="#2c1561" />
      <text
        x="50%"
        y="52%"
        textAnchor="middle"
        fill="white"
        fontSize="22"
        fontWeight="bold"
        fontFamily="Georgia, serif"
        dominantBaseline="middle"
      >
        V
      </text>
    </svg>
  );
}
